import React, { useEffect, useState } from "react";
import { Tabs, Col, Row } from "antd";
import { useLocation } from "react-router-dom";
import AdminUser from "./AdminBlocks/AdminUser";
import AdminAccount from "./AdminBlocks/AdminAccount";
import AdminTeam from "./AdminBlocks/AdminTeam";
import AdminSubscription from "./AdminBlocks/AdminSubscription";

const { TabPane } = Tabs;

const Admin = () => {
  const [defaultTab, setDefaultTab] = useState("1");
  const [loading, setLoading] = useState(true);
  let location = useLocation();
  useEffect(() => {
    const loadRightTab = () => {
      if (location.hash.startsWith("#billing")) {
        setDefaultTab("3");
      }
    };

    loadRightTab();

    setLoading(false);
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <></>;
  } else {
    return (
      <div className="main-container appearance-settings">
        <div className="primary-title">Mon compte Linksight</div>
        <Tabs defaultActiveKey={defaultTab}>
          <TabPane tab="Compte" key="1">
            <Row gutter={20}>
              <Col xl={12} md={12} sm={24} xs={24}>
                {" "}
                <AdminUser />
              </Col>
              <Col xl={12} md={12} sm={24} xs={24}>
                {" "}
                <AdminAccount />
              </Col>
            </Row>
          </TabPane>
          <TabPane tab="Équipe" key="2">
            <AdminTeam />
          </TabPane>
          <TabPane tab="Abonnement" key="3">
            <AdminSubscription />
          </TabPane>
        </Tabs>
      </div>
    );
  }
};

export default Admin;
